import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { FirebaseContext } from "../../firebase";

const RutaProtegida = ({ exact, path, Componente }) => {
    
    const { user, firebase } = React.useContext(FirebaseContext);

    

 return (
  < Route path={path} exact={exact}
   render={() => {
    if (user) {
     return <Componente />
    } else {     
     return <Redirect to={"/"} />
    }
   }} />
 )
}

export default RutaProtegida